<p-dialog
  header="Adresse bearbeiten"
  [modal]="true"
  [(visible)]="displayAddressDialog"
  (onHide)="onHide()"
  [style]="{ width: '400px' }"
  appendTo="body"
>
  <jml-lib-address-control
    #address="ngModel"
    [required]="mandatory"
    [(ngModel)]="rowData[fieldName]"
  ></jml-lib-address-control>
  <button
    pButton
    label="Speichern"
    class="mt-3"
    [disabled]="address.invalid"
    [id]="fieldName + '§' + rowData['id']"
    (click)="onSave()"
  ></button>
</p-dialog>

<div class="cell-view">
  <div class="inner-view">{{ originalContent ? originalContent['repr'] : rowData[fieldName]?.repr }}</div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="AddressCell_Button_edit"
      [attr.data-cy]="AddressCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="AddressCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>
